app.directive("mainNavigation", function () {
	return {
		restrict: "E",
		templateUrl: "app/src/js/directives/nav.html",
		replace: false,
		controller: "mainNavigationController",
	};
});

app.controller("mainNavigationController", [
	"$scope",
	"AuthService",
	"EmailAPI",
	"Session",
	"$timeout",
	"$modal",
	"$state",
	"$location",
	"CurrentPatient",
	"TasksAPI",
	"PatientFormsAPI",
	"$mdDialog",
	"$mdToast",
	"UserService",
	"AppointmentTimerService",
	"CLINIC_LETTER_282",
	"SurgeryWaitlistAPI",
	"SURGERY_WAITLIST_1049",
	"ShareData",
	"InfoPopoverHover",
	"SettingsDialog",
	"ContactDialog",
	"countryConfig",
	"LiveReloadService",
	"PUSH_EVENTS",
	"SurgeryWaitlistLiveUpdateService",
	"TaskLiveUpdateService",
	"LensDispensingStore",
	"CustomFormsDownloaderService",
	"InventoryAPI",
	"$element",
	"PatientImportAPI",
	"PatientImportReview",
	function (
		$scope,
		AuthService,
		EmailAPI,
		Session,
		$timeout,
		$modal,
		$state,
		$location,
		CurrentPatient,
		TasksAPI,
		PatientFormsAPI,
		$mdDialog,
		$mdToast,
		UserService,
		AppointmentTimerService,
		CLINIC_LETTER_282,
		SurgeryWaitlistAPI,
		SURGERY_WAITLIST_1049,
		ShareData,
		InfoPopoverHover,
		SettingsDialog,
		ContactDialog,
		countryConfig,
		LiveReloadService,
		PUSH_EVENTS,
		SurgeryWaitlistLiveUpdateService,
		TaskLiveUpdateService,
		LensDispensingStore,
		CustomFormsDownloaderService,
		InventoryAPI,
		$element,
		PatientImportAPI,
		PatientImportReview
	) {
		// A nav button's number isn't inside the button: angular-material-badge draws it beside it, in the
		// button's list item. So a click on the number is passed on to its button.
		function openFromBadge(event) {
			const badge = event.target.closest && event.target.closest(".nav-li > .md-badge");
			const button = badge && badge.parentElement.querySelector(".md-button");
			if (button) button.click();
		}
		$element.on("click", openFromBadge);
		$scope.$on("$destroy", () => $element.off("click", openFromBadge));

		$scope.AS = AuthService;
		$scope.EA = EmailAPI;
		$scope.CP = CurrentPatient;
		$scope.US = UserService;
		$scope.ATS = AppointmentTimerService;
		$scope.ShareDataService = ShareData;
		$scope.TasksAPI = TasksAPI;
		$scope.PatientFormsAPI = PatientFormsAPI;
		$scope.SurgeryWaitlistAPI = SurgeryWaitlistAPI;
		$scope.message = {};
		$scope.Session = Session;


		// Bumped on every fetchTaskList / fetchWaitlistTasks. A practice switch starts a fresh fetch while
		// the previous practice's pages can still be landing; without this they were appended to the new
		// practice's list and counted in its badge. Declared up here because both fetches run during
		// start-up, before the code further down has executed.
		var taskFetchGeneration = 0;
		var waitlistFetchGeneration = 0;

		function updateFullName() {
			if ($scope.Session.user && $scope.Session.user.firstName !== undefined) {
				var lname = $scope.Session.user.lastName || "";
				var fname = $scope.Session.user.firstName || "";
				$scope.fullName = (fname + " " + lname).trim();
			}
		}

		updateFullName();

		$scope.practices = $scope.Session.practiceOptions;
		$scope.selectedPractice = $scope.Session.practice;
		$scope.recentPatientsFeature = false;
		$scope.navSearch = { open: false };
		$scope.isTaskFeatureEnabled = false;
		$scope.isPaymentTransactionsEnabled = false;
		$scope.isElevenLabsEnabled = false;
		// Same gate as CREATE LETTER in the patient header - letters are off in AU.
		$scope.isClinicLetterEnabled = CLINIC_LETTER_282 && countryConfig.clinicalLettersFeatureEnabled;
		$scope.isSurgeryWaitlistFeatureEnabled = false;
		$scope.patientCustomFormsFeature = false;
		$scope.inventoryFeature = false;
		$scope.lensDispensingFeature = false;
		$scope.dispensingActive = 0;
		$scope.backordersPending = 0;

		this.$onInit = function () {
			$scope.showPatientSearch = false;
			if (Session.practice) {
				$scope.showPatientSearch = true;
			}
		};

		// Which parts of the nav this practice gets. Pulled out of the startup path because the same
		// flags have to be re-read when an admin changes the practice's configuration mid-session - a
		// PRACTICE_UPDATED push event - and not only when the user switches practice.
		function applyPracticeFeatureFlags() {
			const features = ($scope.Session.practice && $scope.Session.practice.practiceFeatures) || null;
			if (features) {
				$scope.isTaskFeatureEnabled = features.sendTasksWithinPracticeFeature;
				$scope.isSurgeryWaitlistFeatureEnabled = SURGERY_WAITLIST_1049;
				$scope.isElevenLabsEnabled = features.elevenLabsAiAgentFeature;
				$scope.isPaymentTransactionsEnabled =
					features.elevenLabsAiAgentFeature ||
					countryConfig.transcriptionFeatureEnabled ||
					features.appointmentSMSReminderFeature;
				$scope.patientCustomFormsFeature = features.patientCustomFormsFeature;
				$scope.inventoryFeature = !!features.inventoryFeature;
				$scope.lensDispensingFeature = !!features.lensDispensingFeature;
				refreshDispensingBadge();
				refreshBackorderBadge();
			}
			$scope.isCalendarEnabled = Session.hasCalendar();
		}


		applyPracticeFeatureFlags();

		$scope.badgeCount = 0;
		if ($scope.isTaskFeatureEnabled) {
			fetchTaskList();
		}

		$scope.waitlistBadgeCount = 0;
		if ($scope.isSurgeryWaitlistFeatureEnabled) {
			fetchWaitlistTasks();
		}

		// Imported patients waiting for review at this practice. The button only shows while there are some,
		// so a practice that never imports patients never sees it. Its badge is a "!" rather than the count: a
		// first import can hold tens of thousands of patients, and that number on every page is alarming.
		$scope.importReviewCount = 0;
		function fetchImportReviewCount() {
			if (!Session.practice || !Session.hasPermission("PATIENT_IMPORT_VIEW")) {
				$scope.importReviewCount = 0;
				return;
			}
			PatientImportAPI.getImportsToReview(0, 0)
				.then(function (resp) {
					$scope.importReviewCount = (resp.data && resp.data.total) || 0;
				})
				.catch(angular.noop);
		}
		fetchImportReviewCount();

		$scope.showImportReviewModal = function () {
			$mdDialog
				.show({
					controller: "patientImportListController",
					templateUrl: "app/src/js/components/patientImport/patientImportList.html",
					parent: angular.element(document.body),
					clickOutsideToClose: true,
					locals: {
						onCountChange: function (count) {
							$scope.importReviewCount = count;
						},
					},
				})
				.catch(angular.noop)
				.finally(fetchImportReviewCount);
		};

		if (Session.user.features && Session.user.features.recentPatientsFeature) {
			$scope.recentPatientsFeature = true;
		}

		$scope.recentPatientsRaw = null;

		// A refresh that lands while the list is on screen is held until the popover
		// closes. The list is fetched again on every hover, and the response routinely
		// arrives just after the popover has opened - swapping the rows out from under
		// the cursor loses the click the user is already part-way through, so clicking
		// straight away appeared to do nothing. Holding it also means the rows cannot
		// reorder between mousedown and mouseup and open a patient they did not click,
		// and that the starred patients below the list do not shift as it resizes.
		var pendingRecentPatients = null;

		function applyRecentPatientsForNav(data) {
			if ($scope.navSearch.open) {
				pendingRecentPatients = data;
				return;
			}
			pendingRecentPatients = null;
			$scope.recentPatientsRaw = data;
		}

		function fetchRecentPatientsForNav() {
			if (!$scope.recentPatientsFeature || !Session.practice) {
				return;
			}
			UserService.getRecentPatients().then(
				function (resp) {
					applyRecentPatientsForNav(resp.data);
				},
				function () {
					// Not logged: the $http error carries the bearer token and the recent-patient list.
				},
			);
		}

		// Held refreshes go in the moment the list is off screen, so the next hover
		// still opens on an up-to-date list.
		$scope.$watch("navSearch.open", function (isOpen) {
			if (!isOpen && pendingRecentPatients) {
				$scope.recentPatientsRaw = pendingRecentPatients;
				pendingRecentPatients = null;
			}
		});

		if ($scope.recentPatientsFeature && Session.practice) {
			fetchRecentPatientsForNav();
		}

		InfoPopoverHover.attachDelayedPopover($scope, {
			isOpenKey: "navSearch.open",
			onEnterKey: "startPatientSearchHover",
			onLeaveKey: "cancelPatientSearchHover",
			onHoverStart: fetchRecentPatientsForNav,
			openDelay: 250,
			closeDelay: 250,
		});

		// fetchTaskList();

		$scope.changeEmail = function () {
			$scope.popoverOpened1 = false;
			$scope.requestSent = false;
			$scope.verifySuccess = false;
			$scope.changeEmailModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.change-email.tpl.html",
				show: true,
				backdrop: "static",
				keyboard: false,
				title: "Current email: " + $scope.Session.user.userName,
			});
		};

		$scope.verifyEmail = function (email) {
			$scope.AS.isProcessing = true;
			$scope.AS.updateEmail(email)
				.then(
					function (resp) {
						$scope.requestSent = true;
					},
					function () {
						$scope.serverErrorModal = $modal({
							scope: $scope,
							templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
							show: true,
							title: "CatTrax has encountered an error",
						});
					},
				)
				.then(function () {
					$scope.AS.isProcessing = false;
				});
		};

		$scope.verifyCode = function (code) {
			$scope.AS.isProcessing = true;
			$scope.AS.verifyEmail(code)
				.then(
					function (resp) {
						$scope.requestSent = false;
						$scope.verifySuccess = true;
					},
					function () {
						$scope.serverErrorModal = $modal({
							scope: $scope,
							templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
							show: true,
							title: "CatTrax has encountered an error",
						});
					},
				)
				.then(function () {
					$scope.AS.isProcessing = false;
				});
		};
		$scope.$watch(
			"Session",
			function (newValue, oldValue) {
				updateFullName();
				if (!newValue.practice) {
					//do nothing
				} else if (!oldValue.practice || newValue.practice.id !== oldValue.practice.id) {
					$scope.showPatientSearch = true;
					$scope.selectedPractice = $scope.Session.practice;
					applyPracticeFeatureFlags();
					fetchImportReviewCount();
					if ($scope.isTaskFeatureEnabled) {
						fetchTaskList();
					}
					if ($scope.isSurgeryWaitlistFeatureEnabled) {
						fetchWaitlistTasks();
					}
					fetchRecentPatientsForNav();
				} else {
					// $scope.showPatientSearch = false;
					// $scope.selectedPractice = null;
				}
				if ($scope.Session.practiceOptions.length > 0) {
					$scope.practices = $scope.Session.practiceOptions;
				}
			},
			true,
		);

		$scope.isLogin = $location.path().indexOf("login") > -1 ? false : true;

		$scope.indicatorWidth = "zero";

		if ($state.current.name === "patient-dashboard") {
			$scope.indicatorWidth = "search";
		}

		$scope.$on("$stateChangeSuccess", function (event) {
			$scope.isLogin = $location.path().indexOf("login") > -1 ? false : true;

			if ($state.current.name === "patient-dashboard") {
				$scope.indicatorWidth = "search";
			}
			if ($state.current.name === "refer.impact") {
				$scope.indicatorWidth = "impact";
			}
			if ($state.current.name === "refer.examination") {
				$scope.indicatorWidth = "examination";
			}
			if ($state.current.name === "refer.complete") {
				$scope.indicatorWidth = "complete";
			}
		});

		$scope.showHelpModal = function () {
			$scope.helpModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.help.tpl.html",
				show: true,
				title: "HELP/FAQ",
			});

			$timeout(function () {
				angular.element("#q1-icon-wrap").triggerHandler("click");
			}, 700);
		};
		$scope.showQuestion = function ($event) {
			angular.element($event.currentTarget).toggleClass("rotate");
			angular.element($event.currentTarget).parents(".q-wrap").find(".q-body-wrap").slideToggle();
		};

		$scope.showFeedBackModal = function () {
			$scope.message = {};
			$scope.feedBackModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.feedback.tpl.html",
				show: true,
				title: "FEEDBACK",
			});
		};
		$scope.sendFeedBackDetails = function (valid) {
			// send feedback form data here... then show success
			if (valid) {
				$scope.EA.isProcessing = true;
				$scope.EA.feedback($scope.message.feedback, $scope.message.subject).then(function (resp) {
					$scope.feedBackModal.hide();
					$scope.EA.isProcessing = false;
					$scope.successFeedBackModal = $modal({
						scope: $scope,
						templateUrl: "app/src/views/templates/modal.success-feedback.tpl.html",
						show: true,
						title: "FEEDBACK SUBMITTED",
					});
				}, function () {
					// Without this the spinner stayed up for good and the failure was silent.
					$scope.EA.isProcessing = false;
					$scope.serverErrorModal = $modal({
						scope: $scope,
						templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
						show: true,
						title: "CatTrax has encountered an error",
					});
				});
			} else {
				console.log("invalid form");
			}
		};

		$scope.showContactModal = function (prefilledMessage) {
			ContactDialog.open(prefilledMessage);
		};

		$scope.closeChangeEmailModal = function () {
			if ($scope.changeEmailModal) {
				$scope.changeEmailModal.hide();
			}
			if ($scope.verifySuccess) {
				$scope.logout();
			}
		};

		$scope.logout = async function () {
			if ($scope.changeEmailModal) {
				$scope.changeEmailModal.hide();
			}
			$scope.CP.clearPatient();
			$scope.ATS.stopTimer();
			// The local session is cleared before this function yields. The LOGOUT button sits inside an
			// <a ui-sref="login">, which navigates on the same click; while the session was still live
			// (it used to survive a 500ms delay plus the server round trip) the login page saw an
			// authenticated user and bounced straight back to welcome. AS.logout() builds its request,
			// Authorization header included, synchronously, so it still carries the token.
			const serverLogout = $scope.AS.logout();
			Session.destroy();
			$scope.ShareDataService.destroy();
			$state.go("login");
			try {
				await serverLogout;
			} catch (error) {
				// The local session is already gone; a failed server logout changes nothing here.
			}
		};

		// Signs in as someone else in this tab only. The sign-in this tab had is left as it is rather than
		// signed out: another tab may be using it - one opened from this tab continues it - and they keep it.
		$scope.switchUser = function () {
			$scope.popoverOpened1 = false;
			$scope.CP.clearPatient();
			$scope.ATS.stopTimer();
			Session.endSignIn();
			Session.destroy();
			$scope.ShareDataService.destroy();
			$state.go("login");
		};

		$scope.changePractice = function (selectedPractice) {
			// The select can only clear itself (its option list was replaced), never be cleared by the user, so
			// a null here is not a choice to leave the practice.
			if (!selectedPractice) {
				$scope.selectedPractice = Session.practice;
				return;
			}
			// Update Session locally, then re-read the practice so its permissions are current - the
			// list was loaded at sign-in, and the user's roles may have changed since.
			Session.setPractice(selectedPractice);
			refreshSessionPractice();

			// Clear search results.
			if ($state.current.url === "/patientDashboard") {
				$scope.CP.clearPatientResult();
			} else {
				$scope.CP.clearPatientResult();
			}
		};

		$scope.searchPatient = function () {
			$scope.navSearch.open = false;
			$scope.CP.clearPatientResult();
			if ($state.current.url === "/patientDashboard") {
				$state.reload();
			} else {
				$state.go("patient-dashboard");
			}
		};

		function showTaskModal() {
			$mdDialog.show({
				controller: "createTaskController",
				templateUrl: "app/src/views/templates/task-list.tmpl.html",
				parent: angular.element(document.body),
				clickOutsideToClose: false,
				scope: $scope.$new(true),
				preserveScope: false,
				resolve: {
					// accounts: () => $scope.accounts,
					patientName: () => "",
					dob: () => "",
					patientId: () => null,
					taskList: () => true,
					createNewTask: () => $scope.createTask,
					updateBadge: () => $scope.updateBadge,
					fetchTask: () => fetchTaskList,
					defaultAssigner: () => null,
				},
			});
		}

		$scope.updateBadge = function (count) {
			$scope.badgeCount = count;
		};

		$scope.showTasksModal = function () {
			showTaskModal();
			// const start = moment().add(-100,'d').utc().toISOString();
			// const end = moment().add(100,'d').utc().toISOString();
			// $scope.TasksAPI.queryAssignedTasks(start,end);
			// $scope.TasksAPI.queryCreatedTasks(start,end);
		};

		// Lens dispensing - the practice's dispensing jobs, laid out like the task list.
		$scope.showDispensingJobsModal = function () {
			$mdDialog.show({
				controller: "lensDispensingJobListController",
				templateUrl: "app/src/js/components/lensDispensing/lens-dispensing-jobs.tmpl.html",
				parent: angular.element(document.body),
				clickOutsideToClose: false,
				scope: $scope.$new(true),
				preserveScope: false,
			})
				.catch(angular.noop)
				.finally(refreshDispensingBadge);
		};

		// The practice's jobs not yet collected, read when the practice changes and whenever a job does.
		function refreshDispensingBadge() {
			if (!$scope.lensDispensingFeature || !$scope.Session.practice) {
				$scope.dispensingActive = 0;
				return;
			}
			LensDispensingStore.loadPracticeJobs()
				.then((rows) => ($scope.dispensingActive = rows.filter((row) => row.job.status !== "COLLECTED").length))
				.catch(angular.noop);
		}
		$scope.$on("lensDispensing:jobs", refreshDispensingBadge);

		$scope.createTask = function (patient) {
			$scope.navSearch.open = false;

			// The open record says whether its patient was imported and still needs reviewing; a task can't be
			// added until it is. (Elsewhere the server refuses the task, and the review is offered then.)
			const open = CurrentPatient.patient;
			if (patient && open && open.id === patient.patientId && open.needs_review) {
				PatientImportReview.open(patient.patientId)
					.then(function (reviewed) {
						showTaskDialog({
							patientId: reviewed.id,
							patientName: [reviewed.firstName, reviewed.lastName].filter(Boolean).join(" "),
							dob: reviewed.dateOfBirth,
						});
					})
					.catch(angular.noop);
				return;
			}
			showTaskDialog(patient);
		};

		function showTaskDialog(patient) {
			$mdDialog.show({
				controller: "createTaskController",
				templateUrl: "app/src/views/templates/create-task.tmpl.html",
				parent: angular.element(document.body),
				clickOutsideToClose: false,
				scope: $scope.$new(true),
				preserveScope: false,
				resolve: {
					// accounts: () => $scope.accounts,
					patientName: () => patient.patientName,
					dob: () => patient.dob,
					patientId: () => patient.patientId,
					taskList: () => false,
					createNewTask: () => null,
					updateBadge: () => $scope.updateBadge,
					fetchTask: () => fetchTaskList,
					defaultAssigner: () => null,
				},
			});
		}

		function fetchCreatedTasks(start, end, pagination) {
			return new Promise((resolve) => {
				$scope.TasksAPI.queryCreatedTasks(start, end, pagination).then(
					function (response) {
						resolve(response);
					},
					function (error) {
						resolve(null);
					},
				);
			});
		}

		function fetchAssignedTasks(start, end, pagination) {
			return new Promise((resolve) => {
				$scope.TasksAPI.queryAssignedTasks(start, end, pagination).then(
					function (response) {
						resolve(response);
					},
					function (error) {
						resolve(null);
					},
				);
			});
		}

		function loopCreatedTasks(start, end, pagination, generation) {
			return fetchCreatedTasks(start, end, pagination).then(function (result) {
				if (generation !== taskFetchGeneration) {
					return;
				}
				if (result && result.data.page_indexes && result.data.page_indexes.length > 0) {
					$scope.createdTasks = [...$scope.createdTasks, ...result.data.tasks];
					return loopCreatedTasks(start, end, result.data.page_indexes, generation);
				} else {
					if (result && result.data && result.data.tasks) {
						$scope.createdTasks = [...$scope.createdTasks, ...result.data.tasks];
					}
				}
			});
		}

		function loopAssignedTasks(start, end, pagination, generation) {
			return fetchAssignedTasks(start, end, pagination).then(function (result) {
				if (generation !== taskFetchGeneration) {
					return;
				}
				if (result && result.data.page_indexes && result.data.page_indexes.length > 0) {
					$scope.assignedTasks = [...$scope.assignedTasks, ...result.data.tasks];
					return loopAssignedTasks(start, end, result.data.page_indexes, generation);
				} else {
					if (result && result.data && result.data.tasks) {
						$scope.assignedTasks = [...$scope.assignedTasks, ...result.data.tasks];
					}
				}
			});
		}

		// The due-date window both task queries are bounded by. Live patches are held to the same window,
		// so a task due outside it cannot be added to a list a refresh would leave it out of.
		function taskDateWindow() {
			return {
				start: moment().add(-100, "d").utc().toISOString(),
				end: moment().add(100, "d").utc().toISOString(),
			};
		}

		// The badge counts this user's outstanding tasks. Taken from the two lists the same way the
		// initial fetch does, so a live patch and a refresh cannot disagree.
		function recountTaskBadge() {
			let allTasks = [...($scope.assignedTasks || [])];
			($scope.createdTasks || []).forEach((t) => {
				allTasks = allTasks.filter((m) => m.task_id !== t.task_id);
				allTasks.push(t);
			});
			$scope.badgeCount = allTasks.filter((t) => !t.is_completed && t.assigned_to_user_id === Session.user.id).length;
		}

		function fetchTaskList() {
			const dueDateWindow = taskDateWindow();
			const generation = ++taskFetchGeneration;
			$scope.assignedTasks = [];
			$scope.createdTasks = [];

			const p1 = loopAssignedTasks(dueDateWindow.start, dueDateWindow.end, null, generation);
			const p2 = loopCreatedTasks(dueDateWindow.start, dueDateWindow.end, null, generation);

			Promise.all([p1, p2])
				.then(
					() => {
						if (generation === taskFetchGeneration) {
							recountTaskBadge();
						}
					},
					// Not logged: a failure here can carry the request's bearer token.
					() => {},
				)
				.then(() => {
					$scope.$apply();
				});
		}

		$scope.$on("waitlist:query", ($event) => {
			fetchWaitlistTasks();
		});
		function fetchWaitlistTasks() {
			const generation = ++waitlistFetchGeneration;
			$scope.allSurgeryWaitlists = [];

			const handleSurgeryWaitlists = (resp) => {
				if (generation !== waitlistFetchGeneration) {
					return;
				}
				if (resp && resp.data.page_indexes && resp.data.page_indexes.length > 0) {
					$scope.allSurgeryWaitlists = [...$scope.allSurgeryWaitlists, ...resp.data.surgery_waitlists];
					updateWaitlistBadge();
					$scope.$broadcast("waitlist:updateAllSurgeryWaitlists", $scope.allSurgeryWaitlists);
					return GetNextPage(resp.data.page_indexes);
				} else {
					$scope.allSurgeryWaitlists = [...$scope.allSurgeryWaitlists, ...resp.data.surgery_waitlists];
					updateWaitlistBadge();
				}
			};

			const GetNextPage = (nextPageIndex) => {
				return new Promise((resolve, error) => {
					$scope.SurgeryWaitlistAPI.getAllSurgeryWaitlistsByPractice(nextPageIndex)
						.then(handleSurgeryWaitlists)
						.catch(() => {
							// Not logged: the $http error carries the bearer token and waitlist patient data.
							error();
						})
						.finally(() => {
							resolve();
						});
				});
			};

			Promise.any([GetNextPage()]).then(() => {
				if (generation !== waitlistFetchGeneration) {
					return;
				}
				updateWaitlistBadge();
				$scope.$broadcast("waitlist:updateAllSurgeryWaitlists", $scope.allSurgeryWaitlists);
			});
		}

		// ---------------------------------------------------------------------------------------------
		// Live updates. The nav is always on screen, so it is where the badges - and the practice's own
		// configuration - are kept current from other users' changes.
		// ---------------------------------------------------------------------------------------------

		// The task badge counts this user's own outstanding tasks, so the only task events worth a
		// request here are ones assigned to them. A task moved *away* from them would otherwise leave
		// the count too high, so a task currently in their list counts as theirs as well.
		//
		// Only the assigned list is passed: the nav also holds the practice-wide list, but the badge is
		// filtered to this user, so keeping the practice one current would be requests spent on a number
		// that cannot change.
		TaskLiveUpdateService.subscribe($scope, {
			assignedTasks: function () {
				return $scope.assignedTasks;
			},
			window: taskDateWindow,
			isRelevant: function (payload) {
				if (!$scope.isTaskFeatureEnabled) {
					return false;
				}
				if (LiveReloadService.sameId(payload.assignedToUserId, Session.userId)) {
					return true;
				}
				return ($scope.assignedTasks || []).some(function (task) {
					return LiveReloadService.sameId(task.task_id, payload.taskId);
				});
			},
			onChanged: function () {
				recountTaskBadge();
			},
		});

		// The waitlist patches the one changed entry rather than paging the practice's whole list. The
		// nav holds that list for the badge, so this runs whether or not the modal is open; re-fetching
		// every page each time anyone edited a waitlist was the most expensive of these live updates.
		// Re-broadcasting the patched list updates an open modal too, so this covers both views.
		SurgeryWaitlistLiveUpdateService.subscribe($scope, {
			waitlists: function () {
				return $scope.allSurgeryWaitlists;
			},
			isRelevant: function () {
				return !!$scope.isSurgeryWaitlistFeatureEnabled;
			},
			onChanged: function () {
				updateWaitlistBadge();
				$scope.$broadcast("waitlist:updateAllSurgeryWaitlists", $scope.allSurgeryWaitlists);
			},
		});

		// An admin changing the practice's feature flags takes effect without a re-login. The event
		// carries no payload - it only says the practice changed - so the practice list is re-read and
		// the session's copy replaced.
		LiveReloadService.subscribe($scope, {
			events: [PUSH_EVENTS.PRACTICE_UPDATED],
			isRelevant: function () {
				return !!Session.practice;
			},
			reload: function () {
				refreshSessionPractice();
			},
			coalesceMs: 1000,
		});

		// A practice's own permission changes arrive as PRACTICE_UPDATED above. A CatTrax change applies at
		// every practice, so there is no single practice to tell; re-reading when the user comes back to
		// the tab picks it up instead. At most once every 5 minutes, the time the server caches permissions for.
		let lastReturnRefresh = Date.now();
		function refreshOnReturn() {
			if (document.visibilityState !== "visible" || !Session.practice) {
				return;
			}
			if (Date.now() - lastReturnRefresh < 5 * 60 * 1000) {
				return;
			}
			lastReturnRefresh = Date.now();
			refreshSessionPractice();
		}
		document.addEventListener("visibilitychange", refreshOnReturn);
		window.addEventListener("focus", refreshOnReturn);
		$scope.$on("$destroy", function () {
			document.removeEventListener("visibilitychange", refreshOnReturn);
			window.removeEventListener("focus", refreshOnReturn);
		});

		CustomFormsDownloaderService.subscribe($scope, {
			csvReady: function (downloadUrl) {
				$mdToast
					.show(
						$mdToast
							.simple()
							.textContent("Your custom form answer is ready")
							.action("Download")
							.highlightAction(true)
							.position("bottom right")
							.hideDelay(0),
					)
					.then(function (response) {
						if (response === "ok") {
							window.open(downloadUrl, "_blank", "noopener");
						}
					});
			},
		});

		// Re-reads the practice the user is working in and re-applies what it enables. The practice id
		// does not change, so the Session watch above does not fire - the flags are re-applied here.
		function refreshSessionPractice() {
			UserService.getUserPractices().then(
				function (resp) {
					// The practice may have been left (signed out) while the list was loading.
					if (!Session.practice) {
						return;
					}
					const practices = resp.data || [];
					const current = practices.find(function (practice) {
						return practice.id === Session.practice.id;
					});
					if (!current) {
						return;
					}

					Session.setPracticeOptions(practices);
					Session.setPractice(current);
					$scope.practices = Session.practiceOptions;
					$scope.selectedPractice = Session.practice;
					applyPracticeFeatureFlags();
				},
				function () {
					// Best effort: the next practice switch or reload picks the change up anyway, and the
					// response carries practice data that must not be logged.
				}
			);
		}

		$scope.$on("waitlist:updateBadge", ($event, updatedWaitlist) => {
			updateWaitlistBadge(updatedWaitlist);
		});
		function updateWaitlistBadge(updatedWaitlist) {
			$scope.waitlistBadgeCount = 0;

			if (updatedWaitlist) {
				let waitlistIndex = $scope.allSurgeryWaitlists.findIndex(
					(surgeryWaitlistView) =>
						surgeryWaitlistView.surgery_waitlist_id === updatedWaitlist.surgery_waitlist_id &&
						surgeryWaitlistView.laterality === updatedWaitlist.laterality,
				);
				// -1 is a normal outcome, not an error: the waitlist modal can show several practices,
				// while the nav only fetches the one the user is working in, and a refresh empties this
				// list while its pages are in flight. Writing at -1 set a junk "-1" property on the array
				// that forEach never visits, so the edit was silently dropped from the count either way.
				if (waitlistIndex !== -1) {
					$scope.allSurgeryWaitlists[waitlistIndex] = updatedWaitlist;
				}
			}

			$scope.allSurgeryWaitlists.forEach((waitlist) => {
				if (waitlist.primary_procedure_od && !waitlist.surgery_completion_date_UTC_map["OD"]) {
					$scope.waitlistBadgeCount++;
				}
				if (waitlist.primary_procedure_os && !waitlist.surgery_completion_date_UTC_map["OS"]) {
					$scope.waitlistBadgeCount++;
				}
			});
		}
		$scope.showSurgeryWaitlistModal = function () {
			$mdDialog.show({
				controller: "surgeryWaitlistController",
				templateUrl: "app/src/views/templates/modal.surgery-waitlist-view.tmpl.html",
				parent: angular.element(document.body),
				clickOutsideToClose: false,
				scope: $scope.$new(true),
				preserveScope: false,
				resolve: {
					allSurgeryWaitlists: () => $scope.allSurgeryWaitlists ?? null,
					currentUser: () => $scope.Session.user,
				},
			});
		};

		$scope.openSetting = function (section) {
			SettingsDialog.openSettings(section);
		};

		$scope.triggerCalendarModal = function (appointment) {
			$scope.selectedAppointment = appointment;
			$scope.openCalendar(null);
		};

		$scope.openCalendar = function (ev) {
			if (ev) {
				$scope.selectedAppointment = null;
			}
			$mdDialog.show({
				controller: "calendarController",
				templateUrl: "app/src/views/templates/calendar.tmpl.html",
				// Appending dialog to document.body to cover sidenav in docs app
				// Modal dialogs should fully cover application to prevent interaction outside of dialog
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				fullscreen: $scope.customFullscreen, // Only for -xs, -sm breakpoints.
				openFrom: "#anchor",
				closeTo: "#anchor",
				scope: $scope.$new(true),
				preserveScope: false,
				resolve: {
					patientId: () => $scope.CP.patient.id,
					patientName: () => $scope.CP.patient.firstName + " " + $scope.CP.patient.lastName,
					selectedAppointment: () => $scope.selectedAppointment,
				},
			});
		};

		$scope.openClinicLetterModal = function () {
			$mdDialog.show({
				controller: "letterTableController",
				templateUrl: "app/src/js/components/clinicLetter/letter-table.tmpl.html",
				parent: angular.element(document.body),
				clickOutsideToClose: false,
				openFrom: "#anchor",
				closeTo: "#anchor",
				scope: $scope.$new(true),
				preserveScope: true,
			});
		};

		$scope.showCustomFormModal = function () {
			PatientFormsAPI.isProcessing = true;
			PatientFormsAPI.getCustomForms()
				.then(function (resp) {
					PatientFormsAPI.isProcessing = false;
					return SettingsDialog.openCustomFormDashboard({
						templates: resp.data,
					});
				})
				.catch(function () {
					// The dialog rejects when dismissed; a failed template request uses the existing error surface.
				})
				.finally(function () {
					PatientFormsAPI.isProcessing = false;
				});
		};

		$scope.showInventoryModal = function () {
			SettingsDialog.openInventory()
				.catch(function () {
					// The dialog rejects when dismissed.
				})
				.finally(refreshBackorderBadge);
		};

		// The practice's backorders still to order in - sold to a patient, not yet ordered. Only for those
		// who may see backorders, so nobody else is shown access-denied pop-ups.
		function refreshBackorderBadge() {
			if (!$scope.inventoryFeature || !$scope.Session.practice || !Session.hasPermission("PRACTICE_INVENTORY_BACKORDER_VIEW")) {
				$scope.backordersPending = 0;
				return;
			}
			InventoryAPI.getBackorders(0)
				.then((resp) => ($scope.backordersPending = (Array.isArray(resp.data) ? resp.data : []).filter((b) => b.status === "PENDING").length))
				.catch(angular.noop);
		}

		// A sale opens a backorder - an invoice, or a lens job invoiced - and moving one on closes it.
		LiveReloadService.subscribe($scope, {
			events: [PUSH_EVENTS.INVENTORY_STOCK_UPDATED],
			isRelevant: () => $scope.inventoryFeature,
			reload: refreshBackorderBadge,
			coalesceMs: 1000,
		});
		$scope.$on("lensDispensing:jobs", refreshBackorderBadge);

		$scope.openAIAgentModal = function () {
			SettingsDialog.openAiAgentSettings();
		};

		$scope.openPaymentTransactions = function () {
			SettingsDialog.openPaymentSettings();
		};

		$scope.faqs = [
			{
				q: "I work at more than one practice but they are not showing in the welcome page.",
				a: "Contact the CatTrax administrators using the Contact/Feedback form with the details of your multiple practices to be added to your profile. ",
			},
			{
				q: "What type of communication should be sent through the Contact/Feedback form?",
				a: "The form is useful for any communication that needs to be made to the CatTrax team. Just select the type of communication in the subject window (feedback, support, urgent, questions on referrals, passwords, update details) to ensure that it is routed to the correct agent.",
			},
			{
				q: "I have searched for a patient that should be in the system and but they have not been found or the details are incorrect.",
				a: "The patient’s last name and date of birth are required to perform a patient search. If multiple patients share the same last name and date of birth, all of these patients will be displayed allowing for you to select the correct one. Please double check the spelling of the patient’s name and the date of birth before creating a new patient record.  Incorrect details can be updated by clicking ‘edit patient’ after selecting a patient.",
			},
			{
				q: "My patient has alerted me to an error in their record or their details have changed.",
				a: "Ensure that their details are correct before searching for them. If that fails to find their record, create a new entry by clicking on the “Register a new patient” button. Ensure that their details are correct before saving.",
			},
			{
				q: "I am unable to edit the patient’s details or progress further with their referral.",
				a: "All patient contact details are updatable through the “Edit patient” window. If the patient is has been registered by another practice then you will need to transfer the patient to your practice using the ‘transfer patient button’ before you can edit their details or complete a referral. Completing a ‘transfer’ will automatically inform the previous optometrist that the patient has been transferred.",
			},
			{
				q: "If my patient has already completed the Impact on Life form, when should they redo it?",
				a: "As this form only takes moments to complete the patient should complete it for every visit unless they feel that they are certain nothing has changed since they last completed the form. If the form is submitted multiple times in too short a period, the results may be subject to auditing.",
			},
			{
				q: "Why can’t I complete the clinical examination details or submit a referral?",
				a: "These tasks can only be completed by optometrists and ophthalmologists.  Practice administration staff can register and edit patient’s details only.",
			},
			{
				q: "Can I enter visual data for my patient after cataract surgery?",
				a: "Yes you can! This data is essential for auditing visual outcomes after surgery so please do this when you see your patients after surgery.",
			},
			{
				q: "Can I enter visual data for my patient without making a referral for cataract surgery?",
				a: "Yes you can! Complete and submit the examination form then return to the main menu without completing a referral.",
			},
			{
				q: "I have completed a referral but the patient has changed their mind and does not want cataract surgery (at all or at the selected provider). What should I do?",
				a: "Please call the provider and quote the referral reference number. You can then redo the CatTrax referral with another provider selected.",
			},
			{
				q: "Can my reception staff enter patient data to streamline the referral process during the consultation?",
				a: "Yes. As long as they have been registered on CatTrax as a Practice Administrator they can perform tasks that include adding or editing patient details, patient practice transfers, and Impact on Life inputs. Only registered clinicians can perform the more advanced visual data inputs and patient referrals.",
			},
		];
	},
]);
